import { useAuth } from '@/providers/auth.provider'
import { Form, Input, Button, Upload, Spin, Image } from 'antd'

import logo from '@/assets/images/icon.png'
import { useTranslation } from 'react-i18next'
import { FORM_TEXT, USER_TEXT } from '@/config/translation/text'
import { useState } from 'react'

function UserInfo() {
  const { user } = useAuth()
  const { t } = useTranslation()
  const [editable] = useState(false)
  const [fileList, setfileList] = useState([])

  const normFile = (e: any) => {
    setfileList(e.fileList)
    if (Array.isArray(e)) {
      return e
    }
    return e?.fileList
  }

  return (
    <Spin spinning={false}>
      <div className="user-info-container">
        <h2>
          <strong>{t(USER_TEXT.PROFILE)}</strong>
        </h2>
        <Form
          initialValues={{
            firstname: user?.first_name,
            lastname: user?.last_name,
            role: user?.subscription?.role_access.role,
            email: user?.email,
            // contact: user?.contactNumber,
            // address: user?.address,
          }}
          name="userprofile"
          labelCol={{ span: 4 }}
          wrapperCol={{ span: 20 }}
          labelAlign="left"
          // onFinish={(payload) => {
          //   mutate({ payload, user, setUser })
          // }}
        >
          <Form.Item
            name={'fileUrl'}
            valuePropName="fileList"
            getValueFromEvent={normFile}
            initialValue={
              user?.avatar?.url_path !== '' || user?.avatar?.url_path !== null
                ? [
                    {
                      uid: '-1',
                      name: user?.avatar?.name,
                      status: 'done',
                      url: user?.avatar?.url_path,
                    },
                  ]
                : []
            }
          >
            {editable ? (
              <Upload
                listType="picture-card"
                maxCount={1}
                method={'GET' as any}
                beforeUpload={() => false}
              >
                {fileList.length > 0 ? null : '  + Picture'}
              </Upload>
            ) : (
              <Image
                loading="lazy"
                width={104}
                src={user?.avatar?.url_path ?? ''}
                fallback={logo}
              />
            )}
          </Form.Item>
          <Form.Item label={t(FORM_TEXT.FIRST_NAME)} name="firstname">
            <Input readOnly={!editable} size="large" disabled />
          </Form.Item>
          <Form.Item label={t(FORM_TEXT.LAST_NAME)} name="lastname">
            <Input readOnly={!editable} size="large" disabled />
          </Form.Item>
          <Form.Item label={t(FORM_TEXT.ROLE)} name="role">
            <Input size="large" readOnly disabled />
          </Form.Item>
          <Form.Item label={t(FORM_TEXT.EMAIL)} name="email">
            <Input size="large" readOnly disabled />
          </Form.Item>

          {editable && (
            <Form.Item wrapperCol={{ offset: 4, span: 20 }}>
              <Button
                type="primary"
                size="large"
                htmlType="submit"
                loading={false}
              >
                Submit
              </Button>
            </Form.Item>
          )}
        </Form>
      </div>
    </Spin>
  )
}

export default UserInfo
